<!--
  2021-06-27 C007 Add for share
-->
<template>
  <div class="page">
    <div class="top-content">
        <div class="content">
          <div>
            <span style="font-size: 32px; ">{{$t('lang.download.textYou')}}</span>
          </div>
          <div style="margin-top: 10px">
            <span style="font-size: 16px; color: #FFF4E2;">{{$t('lang.download.textDownload')}}</span>
          </div>
          <div class="logo-wrapper">
            <img :src="logo" class="logo">
          </div>
          <div class="adescape-text">
            <div>
              <span>{{$t('lang.download.textPlace')}} </span><span class="adescape-text-important">PGEbet</span>
            </div>
            <div>
              <span>{{$t('lang.download.textTheBest')}} </span><span class="adescape-text-important">{{$t('lang.download.textCountry')}}</span>
            </div>
            <div>
              <span>{{$t('lang.download.textLogin')}}</span><span class="adescape-text-important"> {{$t('lang.download.textInstant')}} </span><span>{{$t('lang.download.textGift')}}</span>
            </div>
            <div>
              <span>{{$t('lang.download.textUpto')}}</span><span class="adescape-text-important"> {{$t('lang.download.text10000x')}} </span><span>{{$t('lang.download.textWinning')}}</span>
            </div>
          </div>
        </div>
    </div>
    <div class="bottom-content">
      <div class="download-btn" @click="download">
        <span>{{$t('lang.common.downLoad')}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import logo from '@/assets/images/common/logo3.svg'
import bg from '@/assets/images/common/shareDownloadBg.png'
import config from '../../../static/config/config'
import {LogUtils} from '@/utils'

export default {
  name: 'invite',
  data () {
    return {
      logo,
      bg
    }
  },
  mounted () {
    let shareCode = this.$route.query.s
    LogUtils.setShareCode(shareCode)
  },
  methods: {
    download () {
      const cid = localStorage.getItem('cid') || 'app'
      window.location.href = config.baseURL + 'mobileapp/pge-' + cid + '-' + config.apkVersion + '.apk'
    }
  }
}
</script>
<style lang="less" scoped>
.page{
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  .top-content{
    height: 80vh;
    background-image: url("../../assets/images/common/shareDownloadBg.png");
    background-position: top;
    background-size: contain;
    position: relative;
    .content{
      position: absolute;
      bottom: 0;
      text-align: center;
      width: 100vw;
      color: #F6D9AA;
      margin: 0 0 10px 0;
      font-family: Roboto;

      .logo-wrapper{
        text-align: center;
        margin: 10px 0px;
        .logo{
          margin: 0 auto;
          display: block;
          width: 100px;
          height: 100px;
        }
      }
      .adescape-text{
        font-size: 16px;
        text-align: center;
        color: #F2F2F2;
        margin: 0;
        line-height: 30px;
        font-family: STIXGeneral;
      }

      .adescape-text-important{
        color: #F6D9AA;
        font-style: italic;
      }
    }
  }
  .bottom-content{
    height: 20vh;
    position: relative;
    .download-btn{
      font-size: 18px;
      text-align: center;
      background: #F6D9AA;
      color: #000D2E;
      padding: 10px 0px;
      border-radius: 6px;
      width: 80vw;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Share/download.vue